import { FC, ReactNode } from 'react';

import { Card as MuiCard, Typography, Box, SxProps } from '@mui/material';

type TitleBoxColorTypes = 'blue' | 'orange' | 'yellow' | 'green' | 'purple';

export interface CardProps {
  title: string;
  endAdornment?: ReactNode;
  titleBoxColor?: TitleBoxColorTypes;
  titleBoxText?: string;
  sx?: SxProps;
}

type TitleBoxColors = {
  [key in TitleBoxColorTypes]: string;
};

const titleBoxColors: TitleBoxColors = {
  blue: '#B1E5FC',
  orange: '#FFBC99',
  yellow: '#FFD88D',
  green: '#B5E4CA',
  purple: '#CABDFF',
};

export const Card: FC<CardProps & SxProps> = ({ title, titleBoxColor, titleBoxText, children, endAdornment, sx }) => {
  return (
    <MuiCard sx={{ p: 3, ...sx }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {titleBoxColor && (
            <Box
              sx={{
                height: 32,
                minWidth: 16,
                backgroundColor: titleBoxColors[titleBoxColor],
                borderRadius: '4px',
                mr: 2,
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
              }}
            >
              {titleBoxText && (
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: 600,
                    width: 36,
                    textAlign: 'center',
                  }}
                  color="#1A1D1F"
                >
                  {titleBoxText}
                </Typography>
              )}
            </Box>
          )}

          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
        </Box>

        {endAdornment}
      </Box>
      {children && <Box sx={{ pt: 4, height: '100%' }}>{children}</Box>}
    </MuiCard>
  );
};
